import FormAnswerMultipleChoices from './FormAnswerMultipleChoices';
import { FormAnswerMultipleChoiceProps } from './type';

export default FormAnswerMultipleChoices;
export type { FormAnswerMultipleChoiceProps };
